import { stages } from 'Constants/stages';

export const SKIP_POLLING_STAGES = [stages.FINISHED_ACCEPTED, stages.SUBMITTED, stages.FILED];
